import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Shared ToolCard component
 * Used on homepage and tools landing page
 */
const ToolCard = ({ tool, showTechBadges = true }) => {
  const cardStyle = {
    border: 'none',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    height: '100%'
  };

  const cardHoverStyle = {
    transform: 'translateY(-4px)',
    boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  };

  const badgeStyle = {
    display: 'inline-block',
    padding: '2px 10px',
    backgroundColor: '#edf2f7',
    color: '#4a5568',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
    marginRight: '0.5rem',
    marginBottom: '0.5rem'
  };

  return (
    <Link to={tool.path} style={{ textDecoration: 'none' }}>
      <Card
        style={cardStyle}
        onMouseOver={(e) => Object.assign(e.currentTarget.style, cardHoverStyle)}
        onMouseOut={(e) => Object.assign(e.currentTarget.style, cardStyle)}
      >
        <Card.Body style={{ padding: '2rem' }}>
          <Card.Title style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#2d3748',
            marginBottom: '1rem',
            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
          }}>
            {tool.title}
          </Card.Title>
          <Card.Text style={{
            color: '#4a5568',
            lineHeight: '1.6',
            marginBottom: '1rem',
            fontSize: '0.95rem',
            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
          }}>
            {tool.description}
          </Card.Text>
          {showTechBadges && tool.tech && tool.tech.length > 0 && (
            <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap' }}>
              {tool.tech.map((tech, i) => (
                <span key={i} style={badgeStyle}>{tech}</span>
              ))}
            </div>
          )}
          <span style={{
            color: '#667eea',
            fontWeight: '500',
            fontSize: '0.9rem',
            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
          }}>
            Try it free →
          </span>
        </Card.Body>
      </Card>
    </Link>
  );
};

export default ToolCard;
